/**
 * PDP gallery: clicking a variant's own thumbnail selects that variant.
 *
 * Reads the JSON data island stamped by blocks/_product-media-gallery.liquid
 * (media id -> variant id pairs, plus each variant's option values), then on
 * a thumbnail click finds the matching variant and flips the corresponding
 * radio inputs inside <variant-picker>, dispatching a bubbling "change" so
 * the rest of the picker (price, URL, add-to-cart state) updates the same
 * way it would from a normal click on the picker itself.
 */
document.addEventListener('DOMContentLoaded', () => {
  const dataEl = document.querySelector('script[data-pdp-media-variant-map]');
  if (!dataEl) return;

  let data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  const variants = Array.isArray(data.variants) ? data.variants : [];
  if (!variants.length) return;

  // "mediaId:variantId|mediaId:variantId|..." -> Map<mediaId, variantId>
  const mediaToVariant = new Map();
  (data.pairs || '')
    .split('|')
    .filter(Boolean)
    .forEach((pair) => {
      const [mediaId, variantId] = pair.split(':');
      if (mediaId && variantId) mediaToVariant.set(mediaId, variantId);
    });

  const variantsById = new Map(variants.map((v) => [String(v.id), v]));

  function selectVariant(variant) {
    const pickers = document.querySelectorAll('variant-picker');
    pickers.forEach((picker) => {
      const options = variant.options || [];
      // Match each option value to its own fieldset by position (fieldset
      // order mirrors product.options order, same as variant.options), not
      // by value string alone - two different options could share a value
      // like "Red", and matching on value only would risk checking the
      // wrong fieldset's radio.
      const fieldsets = Array.from(picker.querySelectorAll('fieldset[data-fieldset-index]'));
      fieldsets.sort(
        (a, b) => Number(a.dataset.fieldsetIndex) - Number(b.dataset.fieldsetIndex)
      );

      fieldsets.forEach((fieldset, index) => {
        const value = options[index];
        if (value == null) return;
        const input = fieldset.querySelector(`input[value="${CSS.escape(value)}"]`);
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-media-id]');
    if (!thumb) return;

    const mediaId = thumb.getAttribute('data-media-id');
    const variantId = mediaToVariant.get(mediaId);
    if (!variantId) return;

    const variant = variantsById.get(variantId);
    if (!variant) return;

    selectVariant(variant);
  });
});
